<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <!-- Only render disabled modules in dev mode -->
  <div
    v-if="!disabled || isDev"
    class="card-shell relative transition"
    :class="{
      'opacity-50 pointer-events-none': disabled,
    }">
    <!-- Header -->
    <div :class="compact ? 'card-header-compact' : 'card-header'">
      <slot name="title">
        <div class="flex items-center gap-2">
          <component :is="icon" class="w-6 h-6" v-if="icon" />
          <span class="text-lg font-semibold">{{ title }}</span>
        </div>
      </slot>

      <!-- hide arrowright icon if module does not lead anywhere -->
      <div v-if="!hideAction" class="card-action">
        <slot name="action">
          <ArrowRight class="w-5 h-5" />
        </slot>
      </div>
    </div>

    <!-- Content -->
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<script setup>
  import { ArrowRight } from 'lucide-vue-next'

  defineProps({
    title: String,
    icon: { type: [Object, Function], default: null },
    compact: Boolean,
    hideAction: Boolean,
    disabled: Boolean,
  })

  const isDev = import.meta.env.VITE_ENV !== 'production'
</script>
